import { API as EtlynCmsAPI } from "@etlyn/etlyn-cms";
export const API = EtlynCmsAPI;
export const PublicAPI = EtlynCmsAPI;
export const getAuthUrl = (returnUrl?: string) =>
  `/auth?return_url=${encodeURIComponent(returnUrl || window.location.href)}`;
// This helper reflects the CMS profile, never an independently stored token.
export const isAuthenticated = (): boolean => getCurrentUser() !== null;

// Helper function to get current user
export const getCurrentUser = () => {
  const userProfile = localStorage.getItem("user/profile");
  return userProfile ? JSON.parse(userProfile) : null;
};
